import React from 'react';
import HomeAssessmentLegend from './HomeAssessmentLegend';
import './HomeExplorePanel.css';

/**
 * Legend + goals grid panel (home). Framework switcher stays outside.
 */
const HomeExplorePanel = ({ goalType, copy = {}, children }) => {
  return (
    <div className="home-goals-panel">
      <HomeAssessmentLegend goalType={goalType} copy={copy} />
      {children}
    </div>
  );
};

export default HomeExplorePanel;
